(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-buy"] && !Shopify.designMode) return;
  try {
    
  class PtBuy extends HTMLElement {
    connectedCallback() {
      this.fmtStr = this.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
      this.b2left = parseFloat(this.dataset.b2left) || 0;
      this.b3left = parseFloat(this.dataset.b3left) || 0;
      this.ship = parseInt(this.dataset.ship, 10) || 0;
      this.qtyInput = this.querySelector('[data-pt-qty]');
      this.addBtns = this.querySelectorAll('[data-pt-add]');
      this.slides = this.querySelectorAll('.pt-buy__slide');
      this.querySelectorAll('input[type="radio"][name="id"]').forEach((r) => {
        r.addEventListener('change', () => this.refresh());
      });
      this.querySelectorAll('input[name="pt_bundle"]').forEach((r) => {
        r.addEventListener('change', () => { this.qtyInput.value = r.value; });
      });
      const checked = this.querySelector('input[name="pt_bundle"]:checked');
      if (checked) this.qtyInput.value = checked.value;
    }

    showImage(id) {
      if (!id || !this.slides.length) return;
      let found = false;
      this.slides.forEach((s) => { if (s.dataset.imageId === id) found = true; });
      if (!found) return;
      this.slides.forEach((s) => { s.classList.toggle('is-active', s.dataset.imageId === id); });
    }

    money(cents) {
      const v = (Math.round(cents) / 100).toFixed(2);
      const parts = v.split('.');
      const i = parts[0];
      const d = parts[1];
      const dot = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const comma = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return this.fmtStr.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
        if (key === 'amount_with_comma_separator') return dot + ',' + d;
        if (key === 'amount_no_decimals') return comma;
        if (key === 'amount_no_decimals_with_comma_separator') return dot;
        return comma + '.' + d;
      });
    }

    bundleTotal(n, unit) {
      if (n === 1) return unit;
      const left = n === 2 ? this.b2left : this.b3left;
      if (!(left > 0 && left < 1)) return 0;
      return Math.round(unit * n * left);
    }

    refresh() {
      const v = this.querySelector('input[type="radio"][name="id"]:checked');
      if (!v) return;
      this.showImage(v.dataset.imageId);
      const unit = parseInt(v.dataset.cents, 10);
      const available = v.dataset.available === 'true';
      this.addBtns.forEach((b) => { b.disabled = !available; });
      [1, 2, 3].forEach((n) => {
        const total = this.bundleTotal(n, unit);
        const totalEl = this.querySelector('[data-total="' + n + '"]');
        if (!totalEl || !total) return;
        const full = unit * n;
        const save = full - total;
        totalEl.textContent = this.money(total);
        const was = this.querySelector('[data-was="' + n + '"]');
        const sav = this.querySelector('[data-save="' + n + '"]');
        const per = this.querySelector('[data-per="' + n + '"]');
        const shipTag = this.querySelector('[data-ship-tag="' + n + '"]');
        if (was) { was.textContent = this.money(full); was.hidden = save <= 0; }
        if (sav) { sav.textContent = 'Bespaar ' + this.money(save); sav.hidden = save <= 0; }
        if (per && n > 1) per.textContent = this.money(Math.floor(total / n)) + ' per stuk';
        if (shipTag) shipTag.hidden = !(this.ship && total >= this.ship);
      });
    }
  }
  if (!customElements.get('pt-buy')) customElements.define('pt-buy', PtBuy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-scroll-hero"] && !Shopify.designMode) return;
  try {
    
  class PtStory extends HTMLElement {
    constructor() {
      super();
      this.step = -1;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.stage = this.querySelector('.pt-story__stage');
      this.img = this.querySelector('.pt-story__cut');
      this.product = this.querySelector('.pt-story__product');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.prepareImage();
      if (this.reduce) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            window.addEventListener('resize', this.onScroll, { passive: true });
            this.update();
          } else {
            this.unbind();
          }
        },
        { rootMargin: '150px 0px' }
      );
      this.observer.observe(this);
      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.unbind();
      if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
    }

    unbind() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      const rect = this.getBoundingClientRect();
      const stageHeight = this.stage ? this.stage.offsetHeight : window.innerHeight;
      const total = rect.height - stageHeight;
      const p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
      this.style.setProperty('--p', p.toFixed(3));
      const step = p < 0.22 ? 0 : p < 0.48 ? 1 : p < 0.74 ? 2 : 3;
      if (step !== this.step) {
        this.step = step;
        this.setAttribute('data-step', String(step));
      }
    }

    showBlend() {
      if (this.product) this.product.classList.add('is-blend');
      if (this.img) this.img.classList.add('is-ready');
    }

    prepareImage() {
      const img = this.img;
      if (!img) return;
      const mode = this.getAttribute('data-cutout') || 'auto';
      if (mode === 'off') {
        img.classList.add('is-ready');
        return;
      }
      if (mode === 'blend') {
        this.showBlend();
        return;
      }
      let started = false;
      const run = () => {
        if (started) return;
        started = true;
        this.cutout(img).then((res) => {
          if (res) this.applyCut(res);
          else this.showBlend();
        });
      };
      if (img.complete && img.naturalWidth) {
        run();
      } else if (img.complete) {
        this.showBlend();
      } else {
        img.addEventListener('load', run, { once: true });
        img.addEventListener(
          'error',
          () => {
            if (started) return;
            img.removeAttribute('crossorigin');
            img.addEventListener('load', () => this.showBlend(), { once: true });
            img.src = img.getAttribute('src');
          },
          { once: true }
        );
      }
    }

    cutout(img) {
      return new Promise((resolve) => {
        try {
          const tol = (parseFloat(this.getAttribute('data-tolerance')) || 26) * 2;
          const soft = tol * 1.6;
          const w = img.naturalWidth;
          const h = img.naturalHeight;
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0);
          const imageData = ctx.getImageData(0, 0, w, h);
          const d = imageData.data;

          let r = 0, g = 0, b = 0, n = 0;
          const add = (x, y) => {
            const i = (y * w + x) * 4;
            r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
          };
          for (let x = 0; x < w; x += 4) { add(x, 0); add(x, h - 1); }
          for (let y = 0; y < h; y += 4) { add(0, y); add(w - 1, y); }
          r /= n; g /= n; b /= n;

          const dist = (i) => {
            const dr = d[i] - r, dg = d[i + 1] - g, db = d[i + 2] - b;
            return Math.sqrt(dr * dr + dg * dg + db * db);
          };

          const bg = new Uint8Array(w * h);
          const stack = new Int32Array(w * h);
          let sp = 0;
          let removed = 0;
          const push = (p) => {
            if (!bg[p] && dist(p * 4) <= tol) {
              bg[p] = 1;
              stack[sp++] = p;
              removed++;
            }
          };
          for (let x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
          for (let y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
          while (sp) {
            const p = stack[--sp];
            const x = p % w;
            const y = (p - x) / w;
            if (x > 0) push(p - 1);
            if (x < w - 1) push(p + 1);
            if (y > 0) push(p - w);
            if (y < h - 1) push(p + w);
          }

          const ratio = removed / (w * h);
          if (ratio < 0.06 || ratio > 0.92) {
            resolve(false);
            return;
          }

          let minX = w, minY = h, maxX = 0, maxY = 0;
          for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
              const p = y * w + x;
              const i = p * 4;
              if (bg[p]) {
                d[i + 3] = 0;
                continue;
              }
              const nearBg = (x > 0 && bg[p - 1]) || (x < w - 1 && bg[p + 1]) || (y > 0 && bg[p - w]) || (y < h - 1 && bg[p + w]);
              if (nearBg) {
                const dd = dist(i);
                if (dd < soft) d[i + 3] = Math.max(0, Math.min(255, (255 * (dd - tol)) / (soft - tol)));
              }
              if (d[i + 3] > 24) {
                if (x < minX) minX = x;
                if (x > maxX) maxX = x;
                if (y < minY) minY = y;
                if (y > maxY) maxY = y;
              }
            }
          }
          if (maxX <= minX || maxY <= minY) {
            resolve(false);
            return;
          }

          ctx.putImageData(imageData, 0, 0);
          const pad = Math.round(Math.max(w, h) * 0.02);
          minX = Math.max(0, minX - pad);
          minY = Math.max(0, minY - pad);
          maxX = Math.min(w - 1, maxX + pad);
          maxY = Math.min(h - 1, maxY + pad);
          const ow = maxX - minX + 1;
          const oh = maxY - minY + 1;
          const out = document.createElement('canvas');
          out.width = ow;
          out.height = oh;
          out.getContext('2d').drawImage(canvas, minX, minY, ow, oh, 0, 0, ow, oh);
          out.toBlob((blob) => {
            if (!blob) {
              resolve(false);
              return;
            }
            this.blobUrl = URL.createObjectURL(blob);
            resolve({ url: this.blobUrl, w: ow, h: oh });
          }, 'image/png');
        } catch (err) {
          resolve(false);
        }
      });
    }

    applyCut(res) {
      const img = this.img;
      img.addEventListener('load', () => img.classList.add('is-ready'), { once: true });
      img.removeAttribute('crossorigin');
      img.setAttribute('width', res.w);
      img.setAttribute('height', res.h);
      img.src = res.url;
    }
  }

  if (!customElements.get('pt-story')) {
    customElements.define('pt-story', PtStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pt-showcase"] && !Shopify.designMode) return;
  try {
    
  class PtShowcase extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
    }
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.update();
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      }, { rootMargin: '100px 0px' });
      this.io.observe(this);
      this.update();
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      window.removeEventListener('scroll', this.onScroll);
    }
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => { this.ticking = false; this.update(); });
    }
    update() {
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight;
      const p = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
      this.style.setProperty('--p', p.toFixed(3));
    }
  }
  if (!customElements.get('pt-showcase')) customElements.define('pt-showcase', PtShowcase);

  } catch(e) { console.error(e); }
})();
})();
